import { ReactNode } from 'react'
import { Avatar, Popover } from '@systemeio/components'

export interface CustomRenderMentionProps {
  element: {
    id: number
    displayName: string
    profileImageUrl: string
  }
}

export const Mention = ({ element }: CustomRenderMentionProps): ReactNode => {
  return (
    <Popover.Root>
      <Popover.Trigger
        openOnHover
        delay={0}
        nativeButton={false}
        render={triggerProps => (
          <span
            {...triggerProps}
            className="relative inline-block align-baseline text-text-link no-underline hover:underline max-[750px]:max-w-full max-[750px]:wrap-break-word"
            contentEditable={false}
            data-cy={`mention-${element.displayName.replace(' ', '-')}`}
            data-avatar-url={element.profileImageUrl || ''}
            data-id={element.id || 0}
          >
            @{element.displayName}
          </span>
        )}
      />
      <Popover.Portal>
        <Popover.Positioner side="top" align="start">
          <Popover.Popup
            className="z-10000 my-1.5 flex w-max max-w-xs items-center gap-2.5 overflow-hidden rounded-lg border-0 p-4 shadow-2"
            contentEditable={false}
          >
            <Avatar
              src={element.profileImageUrl || undefined}
              displayName={element.displayName}
              alt={element.displayName}
              size="lg"
            />
            <p className="min-w-0 truncate font-black">{element.displayName}</p>
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  )
}
